<script setup>
  const shouldShowBar = ref(true);
</script> 

<template>
    <div class="h-10 bg-cool-gray flex items-center" v-if="shouldShowBar">
      <Container>
        <div class="flex items-center relative">
          <div class="w-5 h-5 cursor-pointer flex items-center">
            <IconArrowLeft class="!w-3.5 !h-3.5" />
          </div>

          <NuxtLink to="/" class="inline-block mr-1"><span class="font-extralight inline-block mr-1">Przejdź na</span>VEHIS.pl</NuxtLink>
            <IconClose @click="shouldShowBar = false" class="absolute right-0 top-0 cursor-pointer !w-5 h-5" />
        </div>
      </Container>
    </div>
</template>